import { useState } from 'react';
import { PROFILE_MIN_AGE } from '../data/constants';

function isUnderFourteen(birthDate) {
    if (!birthDate) return false;
    const birth = new Date(birthDate);
    if (Number.isNaN(birth.getTime())) return false;
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const hadBirthdayThisYear =
        today.getMonth() > birth.getMonth() ||
        (today.getMonth() === birth.getMonth() && today.getDate() >= birth.getDate());
    if (!hadBirthdayThisYear) age -= 1;
    return age < PROFILE_MIN_AGE;
}

export default function NicknameSetup({ defaultName, defaultEmail, profile = {}, onSave }) {
    const [name, setName] = useState(defaultName || '');
    const [birthDate, setBirthDate] = useState(profile.birthDate || '');
    const [gender, setGender] = useState(profile.gender || '');
    const [email, setEmail] = useState(profile.email || defaultEmail || '');
    const [phone, setPhone] = useState(profile.phone || '');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const underFourteen = isUnderFourteen(birthDate);
    const ageError = underFourteen ? '이용 약관상 만 14세 미만은 이용하실 수 없어요' : '';
    const canSubmit = Boolean(
        name.trim() && birthDate && gender && email.trim() && phone.trim() && !underFourteen && !saving
    );

    const handleSave = async () => {
        const trimmed = name.trim();
        if (!trimmed || !birthDate || !gender || !email.trim() || !phone.trim()) {
            setError('모든 정보를 입력해주세요.');
            return;
        }
        if (underFourteen) {
            setError(ageError);
            return;
        }
        setSaving(true);
        setError('');
        try {
            await onSave({ nickname: trimmed, birthDate, gender, email, phone });
        } catch (e) {
            const messages = {
                email_taken: '이미 사용 중인 이메일주소예요.',
                phone_taken: '이미 사용 중인 전화번호예요.',
                required: '모든 정보를 입력해주세요.',
            };
            setError(messages[e.message] || '저장에 실패했어요. 잠시 후 다시 시도해주세요.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="login-screen">
            <div className="login-card profile-setup-card">
                <div className="login-logo">✦</div>
                <div className="login-title">반갑습니다!</div>
                <div className="login-sub">운동 기록에 필요한 기본 정보를 입력해주세요.</div>
                <div style={{ width: '100%' }}>
                    <label className="setup-label">닉네임</label>
                    <input
                        className="form-input"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="닉네임 입력"
                        maxLength={20}
                        autoFocus
                    />
                </div>
                <div className="setup-grid">
                    <div>
                        <label className="setup-label">생년월일</label>
                        <input
                            className="form-input"
                            type="date"
                            value={birthDate}
                            onChange={e => {
                                setBirthDate(e.target.value);
                                setError('');
                            }}
                        />
                    </div>
                    <div>
                        <label className="setup-label">성별</label>
                        <select className="form-input" value={gender} onChange={e => setGender(e.target.value)}>
                            <option value="">선택</option>
                            <option value="male">남성</option>
                            <option value="female">여성</option>
                            <option value="other">기타</option>
                            <option value="private">응답하지 않음</option>
                        </select>
                    </div>
                </div>
                <div style={{ width: '100%' }}>
                    <label className="setup-label">이메일주소</label>
                    <input
                        className="form-input"
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="email@example.com"
                        autoCapitalize="none"
                    />
                </div>
                <div style={{ width: '100%' }}>
                    <label className="setup-label">전화번호</label>
                    <input
                        className="form-input"
                        type="tel"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                        placeholder="01012345678"
                    />
                </div>
                {(ageError || error) && <div className="setup-error">{ageError || error}</div>}
                <button
                    className="google-btn"
                    style={{ marginTop: 4, background: 'var(--accent)', color: '#0f0f0f', border: 'none' }}
                    onClick={handleSave}
                    disabled={!canSubmit}
                >
                    {saving ? '확인 중...' : '시작하기'}
                </button>
            </div>
        </div>
    );
}
